import { render, staticRenderFns } from "./ItemGroupView.vue?vue&type=template&id=4fe42ead&scoped=true&"
import script from "./ItemGroupView.vue?vue&type=script&lang=ts&"
export * from "./ItemGroupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe42ead",
  null
  
)

export default component.exports